<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M5.75806 3C6.71981 3 7.66667 3.47796 7.66667 4.62121C7.66667 5.67549 6.54711 6.08094 6.30667 6.46189C6.12617 6.74526 6.18645 7.14344 5.69051 7.14344C5.36744 7.14344 5.20963 6.85988 5.20963 6.60042C5.20963 5.63493 6.52424 5.41642 6.52424 4.6214C6.52424 4.18381 6.25436 3.92436 5.80328 3.92436C4.84153 3.92436 5.21708 4.99432 4.48868 4.99432C4.22572 4.99432 4 4.82403 4 4.4999C3.99982 3.7047 4.84118 3 5.75806 3ZM5.72065 7.66981C6.05826 7.66981 6.33681 7.96945 6.33681 8.33491C6.33681 8.70036 6.05879 9 5.72065 9C5.38251 9 5.10431 8.70075 5.10431 8.33491C5.10431 7.96964 5.38251 7.66981 5.72065 7.66981Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconRoundQuestionMark"
}
</script>